module.exports = __webpack_public_path__ + "static/media/ben_shen_cv.aeb66feb.pdf";